module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/classic-tee/22-e49b54620d9766405db3ee6aa859bc78.jpg";